import { useQuery } from 'react-query';

import AssessmentService from 'App/services/AssessmentService';

function useFetchAssessmentRiskDetails(assessmentId, riskId) {
    return useQuery(
        ['assessmentId', assessmentId, 'riskId', riskId, 'details'],
        () => (!riskId ? null : AssessmentService.getRiskDetails(assessmentId, riskId)),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchAssessmentRiskDetails;
